import { all, call, put } from 'redux-saga/effects'

import { secureSanitize } from '../../utils/sanitizeUtils'
import { Recipes } from '../../graphql/Services'
import { actions } from '..'
import ApiSagas from '../api/sagas'
import { Recipe } from '../../types/fam-graphql'
import { offlineQuery } from '../../utils/CacheUtils'
import Router from '../../routes/router'
import definitions from '../../routes/definitions'

export default class RecipeSagas {
  static *init({ query }: any) {
    const { slug, side, jour, day, moment } = query

    const sanitizedSlug = secureSanitize(slug, true)
    const sanitizedSide = secureSanitize(side, true)
    const sanitizedJour = secureSanitize(jour, true)
    const sanitizedDay = secureSanitize(day, true)
    const sanitizedMoment = secureSanitize(moment, true)

    return yield call(RecipeSagas.loadPage, {
      slug: sanitizedSlug,
      side: sanitizedSide,
      day: sanitizedJour ?? sanitizedDay,
      moment: sanitizedMoment,
    })
  }

  static *loadPage({
    slug,
    side,
  }: {
    slug: string
    side?: string
    day?: string
    moment?: string
  }) {
    const rs = yield call(
      offlineQuery,
      Router.getRouteUrl(definitions.recipe.name, { slug }),
      () => call(ApiSagas.query, Recipes.queries.recipeBySlug({ slug: slug })),
      true
    )
    const recipe: Recipe = rs?.data

    yield put(actions.recipe.setRecipe(recipe))

    if (!recipe) {
      return { error: 404 }
    }

    // In case a recipe is composed by "COURSE" + "SIDE"
    if (side) {
      const sideRs = yield call(
        offlineQuery,
        Router.getRouteUrl(definitions.recipe.name, { slug: side }),
        () =>
          call(ApiSagas.query, Recipes.queries.recipeBySlug({ slug: side })),
        true
      )
      const sideData = sideRs?.data

      yield put(actions.recipe.setSide(sideData))

      if (!sideData) {
        return { error: 404 }
      }
    } else {
      yield put(actions.recipe.setSide(null))
    }
  }

  static *loop() {
    yield all([
      //
    ])
  }
}
